import React from 'react';

import { FontSize, IDesignTokens } from '../../../typings/design-tokens';
// import { makeClassNames } from '../../../utils/styles';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import Team, { ITeam, TeamLogoSize } from '../team/team';

import './teams-list.scss';

export interface ITeamsList extends IDesignTokens, IComponent {
  teams: ITeam[];
  logoSize?: TeamLogoSize;
}

const classNames = () =>
  makeClassNames({
    teamsList: 'teams-list',
    teamsListTeam: 'teams-list-team',
  });

const DEFAULT_TEXT_FONT_SIZE: FontSize = '16';
const DEFAULT_LOGO_SIZE: TeamLogoSize = '30';

const TeamsList = ({
  /* istanbul ignore next: default value on mandatory field */ teams = [],
  /* istanbul ignore next: default value on mandatory field */ fontSize = DEFAULT_TEXT_FONT_SIZE,
  /* istanbul ignore next: default value on mandatory field */ logoSize = DEFAULT_LOGO_SIZE,
  /* istanbul ignore next: default value on mandatory field */ trackingData = {},
}: ITeamsList) => {
  const cn = classNames();

  return (
    <div className={cn.teamsList}>
      {teams
        .sort((prev: ITeam, next: ITeam) => prev.name.toUpperCase().localeCompare(next.name.toUpperCase()))
        .map((team) => {
          team.clickable = true;
          return (
            <div key={team.id} className={cn.teamsListTeam}>
              <Team
                {...team}
                fontSize={fontSize}
                logoSize={logoSize}
                fontWeight="500"
                ellipsis
                dataAttributes={trackingData}
              />
            </div>
          );
        })}
    </div>
  );
};

export default TeamsList;
